import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { IsString, IsUUID, MaxLength, MinLength } from 'class-validator';
import { Exclude, Expose } from 'class-transformer';
import {
  BUILDING_NOTES_MAX_LENGTH,
  BUILDING_NOTES_MIN_LENGTH,
  BUILDING_NUMBER_MAX_LENGTH,
  BUILDING_NUMBER_MIN_LENGTH,
} from '../constants/building-validation.constants';
import { BuildingInterface } from '../interfaces/building.interface';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { SubdivisionDto } from '../../subdivision/dto/subdivision.dto';
import { JobDto } from '../../job/dto/job.dto';

@Exclude()
export class BuildingDto extends CommonEntityDto implements BuildingInterface {
  @ApiProperty({
    title: 'Number',
    description: 'The building number',
    minLength: BUILDING_NUMBER_MIN_LENGTH,
    maxLength: BUILDING_NUMBER_MAX_LENGTH,
  })
  @IsString()
  @MinLength(BUILDING_NUMBER_MIN_LENGTH)
  @MaxLength(BUILDING_NUMBER_MAX_LENGTH)
  @Expose()
  number!: string;

  @ApiProperty({
    title: 'Notes',
    description: 'Notes about the building',
    minLength: BUILDING_NOTES_MIN_LENGTH,
    maxLength: BUILDING_NOTES_MAX_LENGTH,
  })
  @IsString()
  @MinLength(BUILDING_NOTES_MIN_LENGTH)
  @MaxLength(BUILDING_NOTES_MAX_LENGTH)
  @Expose()
  notes!: string;

  @ApiProperty({
    format: 'uuid',
    title: 'Subdivision ID',
    description: 'The id of the associated subdivision.',
  })
  @IsUUID()
  @Expose()
  subdivisionId!: string;

  @ApiPropertyOptional({
    type: () => SubdivisionDto,
    title: 'Associated Subdivision',
    description: 'The subdivision associated with this building',
  })
  @Expose()
  subdivision?: SubdivisionDto;

  @ApiPropertyOptional({
    type: () => [JobDto],
    title: 'Associated Jobs',
    description: 'The jobs associated with this building',
  })
  @Expose()
  jobs?: JobDto[];
}
